<template>
  <div>
    <Transition name="fade">
      <div v-if="show"
        class="fixed z-40 top-0 left-0 w-screen h-screen bg-black/75"
        @click="close"></div>
    </Transition>
    <Transition name="slide-up">

      <div v-if="show"
        class="fixed bg-green-500 text-white z-50 bottom-0 left-0 w-screen h-3/4 rounded-t-2xl pb-safe">
        <div>

          <div class="text-center pt-6 pb-12 text-xl font-bold">
            {{ title }}
          </div>

          <div class="flex flex-col justify-center items-center">
            <div class="w-full justify-center items-center text-center">

              <label class="text-lg ">
                <span v-if="error">
                  {{ error }}
                </span>
                <span v-else>
                  {{ description }}
                </span>
              </label>

              <div class="flex px-12 pt-6 pb-2 relative">
                <div v-for="_, n in pinArray" :key="n"
                  class="w-1/6 flex items-center justify-center">
                  <Transition name="dash-to-circle">
                    <MinusIcon v-if="position <= n" class="h-6 w-6 stroke-2" />
                    <div v-else class="h-6 w-6 bg-white rounded-full"></div>
                  </Transition>
                </div>
              </div>

            </div>

            <!-- Numerical board -->
            <div
              class="grid grid-cols-3 justify-center items-center w-full flex-wrap">
              <div v-for="pinDigit in pinDigits"
                class="text-center py-6 text-2xl underline-offset-8 underline"
                @click="setValue(pinDigit.value)">
                {{ pinDigit.value }}
              </div>


              <div
                class="text-center py-6 flex itesm-center justify-center underline-offset-8 underline">
                <Transition name="fade">
                  <ChevronLeftIcon v-if="position > 0" class="h-6 w-6 stroke-2"
                    @click="removeValue" />
                </Transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { ChevronLeftIcon, MinusIcon } from '@heroicons/vue/24/outline'

const emit = defineEmits<{
  (e: 'close'): void,
  (e: 'confirmed', value: string): void
}>()

defineProps<{
  show: boolean,
  title: string,
  description: string,
  error: string | null
}>()


const close = () => {
  reset()
  emit('close')
}

const loading = ref(false)

// initialise an array of 6 empty strings
const pinArray = ref<Array<string>>(Array(6).fill(''))
const position = ref(0)

const setValue = (value: string) => {
  if (loading.value) return
  if (position.value < 6) {
    pinArray.value[position.value] = value
    position.value++
  }

  if (position.value === 6) {
    loading.value = true
    setTimeout(() => {
      emit('confirmed', pinArray.value.join(''))
      reset()
      loading.value = false
    }, 500)
  }
}

const removeValue = () => {
  if (loading.value) return
  if (position.value > 0) {
    position.value--
    pinArray.value[position.value] = ''
  }
}

const reset = () => {
  position.value = 0
  pinArray.value = Array(6).fill('')
}

const pinDigits = [
  { value: '1' },
  { value: '2' },
  { value: '3' },
  { value: '4' },
  { value: '5' },
  { value: '6' },
  { value: '7' },
  { value: '8' },
  { value: '9' },
  { value: '' },
  { value: '0' },
]
</script>

<style scoped>
/*  */
.dash-to-circle-enter-active,
.dash-to-circle-leave-active {
  transition: all 0.25s;
  position: absolute;
}

.dash-to-circle-enter-from {
  transform: scale(0) rotate(0deg);
}

.dash-to-circle-enter-to {
  transform: scale(1) rotate(180deg);
}

.dash-to-circle-leave-from {
  transform: scale(1) rotate(180deg);
}

.dash-to-circle-leave-to {
  transform: scale(0) rotate(0deg);
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.25s;
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
}

.slide-up-enter-to,
.slide-up-leave-from {
  transform: translateY(0);
}
</style>